import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function ServiceGateway() {
  const { t } = useTranslation();

  const services = [
    {
      key: "cruise",
      to: "/services/cruise",
      image: "/images/services/cruise/hero.jpg",
      gradient: "from-blue-950/80 via-blue-900/55 to-blue-900/35",
    },
    {
      key: "employment",
      to: "/services/employment",
      image: "/images/about/meeting.jpg",
      gradient: "from-slate-950/80 via-slate-900/60 to-slate-900/35",
    },
  ];

  return (
    <section className="min-h-[calc(100dvh-64px)] bg-slate-950">
      <div className="grid min-h-[calc(100dvh-64px)] grid-cols-1 md:grid-cols-2">
        {services.map((service) => (
          <article
            key={service.key}
            className="group relative isolate flex min-h-[50dvh] items-end overflow-hidden md:min-h-[calc(100dvh-64px)]"
          >
            <img
              src={service.image}
              alt=""
              className="absolute inset-0 -z-20 h-full w-full object-cover transition duration-500 group-hover:scale-105"
              loading="lazy"
              decoding="async"
            />
            <div
              className={`absolute inset-0 -z-10 bg-gradient-to-b ${service.gradient}`}
            />
            <div className="w-full p-7 md:p-12">
              <p className="text-xs font-semibold uppercase tracking-[0.2em] text-blue-200">
                {t(`serviceGateway.${service.key}.eyebrow`)}
              </p>
              <h1 className="mt-3 text-3xl font-extrabold tracking-tight text-white md:text-5xl">
                {t(`serviceGateway.${service.key}.title`)}
              </h1>
              <p className="mt-3 max-w-lg text-sm leading-6 text-slate-100 md:text-base">
                {t(`serviceGateway.${service.key}.desc`)}
              </p>
              <Link
                to={service.to}
                className="mt-6 inline-flex items-center rounded-xl bg-white px-5 py-2.5 text-sm font-semibold text-slate-900 transition hover:bg-blue-50"
              >
                {t("serviceGateway.cta")}
                <ArrowRight className="ml-1 h-4 w-4" />
              </Link>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
